export default __webpack_public_path__ + "static/media/Calander.8f7d271d.svg";